import { useMemo } from 'react';
// @ts-ignore
import { v4 } from 'uuid';
/**
 * Hook that returns unique id which is persistent during whole component lifecycle
 */
export const useUniqueId = (staticId) => useMemo(() => staticId ?? v4(), [staticId]);
